import { Routes } from '@angular/router';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { NotAccessibleComponent } from './pages/other-page/not-accessible/not-accessible.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { ResetPasswordComponent } from './pages/auth-pages/reset-password/reset-password.component';
import { ChangePasswordRequiredComponent } from './pages/auth-pages/change-password-required/change-password-required.component';
import { TwoFactorMethodSelectionComponent } from './pages/auth-pages/two-factor-method-selection/two-factor-method-selection.component';
import { authGuard } from './shared/guards/auth.guard';
import { resetPasswordGuard } from './shared/guards/reset-password.guard';

export const routes: Routes = [
  {
    path: '',
    component: SignInComponent,
    pathMatch: 'full',
    title: 'Sign In | AbuseXense'
  },

  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        title: 'Dashboard | AbuseXense',
      },
      {
        path: 'monitor',
        loadComponent: () => import('./pages/monitor/monitor.component').then(m => m.MonitorComponent),
        title: 'Domain Monitoring | AbuseXense'
      },
      {
        path: 'monitor/:domain',
        loadComponent: () => import('./pages/monitor/monitor-domain-detail/monitor-domain-detail.component').then(m => m.MonitorDomainDetailComponent),
        title: 'Domain Details | AbuseXense'
      },
      {
        path: 'abuse',
        loadComponent: () => import('./pages/abuse/abuse-case/abuse.component').then(m => m.AbuseComponent),
        title: 'Abuse Cases | AbuseXense'
      },
      {
        path: 'abuse/:id',
        loadComponent: () => import('./pages/abuse/abuse-case-detail/abuse-case-detail.component').then(m => m.AbuseCaseDetailComponent),
        title: 'Abuse Case Details | AbuseXense'
      },
      {
        path: 'tenant',
        loadComponent: () => import('./pages/tenant/tenant-management/tenant-management.component').then(m => m.TenantManagementComponent),
        title: 'Tenant Management | AbuseXense',
        pathMatch: 'full',
        canActivate: [authGuard],
        data: { requiresAdminAccess: true },
      },
      {
        path: 'tenant/:id',
        loadComponent: () => import('./pages/tenant/tenant-management-details/tenant-management-details.component').then(m => m.TenantManagementDetailsComponent),
        title: 'Tenant Details | AbuseXense',
        canActivate: [authGuard],
        data: { requiresAdminAccess: true },
      },
      {
        path: 'email',
        loadComponent: () => import('./pages/email/email-template/email.component').then(m => m.EmailComponent),
        title: 'Email Templates | AbuseXense'
      },
      {
        path: 'email/:id',
        loadComponent: () => import('./pages/email/email-template-detail/email-template-detail.component').then(m => m.EmailTemplateDetailComponent),
        title: 'Email Templates Details | AbuseXense'
      },
      {
        path: 'config',
        loadComponent: () => import('./pages/configuration/configuration.component').then(m => m.ConfigurationComponent),
        title: 'Configuration | AbuseXense'
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/user-settings/user-settings.component').then(m => m.UserSettingsComponent),
        title: 'User Settings | AbuseXense'
      },
      {
        path: 'resource-access-management',
        loadComponent: () => import('./pages/resource-access-management/resource-access-management').then(m => m.ResourceAccessManagementComponent),
        title: 'Resource Access Management | AbuseXense'
      },
      {
        path: 'resource-access-management/roles/:id',
        loadComponent: () => import('./pages/resource-access-roles-detail/resource-access-role-detail').then(m => m.ResourceAccessRoleDetailComponent),
        title: 'Role Details | AbuseXense'
      },
      {
        path: 'resource-access-management/users/:id',
        loadComponent: () => import('./pages/resource-access-users-detail/resource-access-user-detail').then(m => m.ResourceAccessUserDetailComponent),
        title: 'User Details | AbuseXense'
      },
    ]
  },
  // auth pages
  {
    path: 'signin',
    component: SignInComponent,
    title: 'Sign In | AbuseXense'
  },
  {
    path: 'login',
    component: SignInComponent,
    title: 'Sign In | AbuseXense'
  },
  {
    path: 'change-password-required',
    component: ChangePasswordRequiredComponent,
    title: 'Change Password Required | AbuseXense'
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [resetPasswordGuard],
    title: 'Reset Password | AbuseXense'
  },
  {
    path: 'two-factor-method',
    component: TwoFactorMethodSelectionComponent,
    title: 'Two-Factor Method Setup | AbuseXense'
  },
  // error pages
  {
    path: 'noaccess',
    component: NotAccessibleComponent,
    title: 'Forbidden Access | AbuseXense'
  },
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Page Not Found | AbuseXense'
  },
];
